<template>
    <div v-if="contextMenuVisible" class="list-actions contextMenu" :style="style" ref="contextMenu">
        <dd :class="`list-action-item${item.divided ? ' divided' : ''}${item.danger ? ' action-danger' : ''}`" v-for="item in menu" :key="item.key" @click="handleAction(item.key)">
            <div class="list-action-inner"><div class="list-name">{{$t(item.key == 'Star' ? contextData.stared ? 'Unstar' : 'Star' : item.key)}}</div></div>
        </dd>
    </div>
</template>

<script>
import {mapState,mapMutations,mapActions} from 'vuex'
import clickoutside from '@/directives/clickoutside'
import {menus} from '@/config'
export default {
    methods:{
        ...mapMutations([
            'HIDE_CONTEXTMENU',
            'SHOW_DIALOG'
        ]),
        ...mapActions('index',[
            'star',
            'unstar',
            'download'
        ]),
        clickoutside(e){
            let contextMenu = this.$refs.contextMenu
            if (!contextMenu.contains(e.target)) {
                this.HIDE_CONTEXTMENU()
            }
        },
        handleAction(type){
            let {fileid,ext,name,ftype,fname,groupid,sid,tid,tname,parentid,share} = this.contextData
            if (type == 'Share') {
                if(share == 'shared'){
                    this.SHOW_DIALOG({
                        title: name,
                        size: 'large',
                        current: 'share',
                        dialogIco: ext,
                        dialogData:{
                            fileid,
                            groupid,
                            share
                        }
                    })
                }else{
                    this.SHOW_DIALOG({
                        title: name,
                        size: 'large',
                        current: 'share',
                        dialogIco: ext,
                        dialogData:{
                            fileid,
                            sid,
                            groupid
                        }
                    })
                }
            }else if(type == 'Star'){
                this.contextData.stared ? this.unstar({fileid,sid,groupid}) :
                this.star({fileid,sid,groupid})
            }else if(type == 'Copy'){
                this.SHOW_DIALOG({
                    current: 'Copy',
                    smodule: 'index',
                    size: 'large',
                    title: this.$t('Copyto'),
                    dialogData: {
                        fileid,
                        groupid
                    }
				})
            }else if(type == 'Move'){
                this.SHOW_DIALOG({
                    current: 'MoveFile',
                    size: 'large',
                    title: this.$t('Movefile'),
                    dialogData: {
                        fileid,
                        groupid
                    }
                })
            }else if(type == 'Rename'){
                this.SHOW_DIALOG({
                    current: 'Rename',
                    title: tid ? this.$t('Rename') : this.$t('Renamefile'),
                    dialogData: {
                        name,
                        ext,
                        fileid,
                        ftype,
                        groupid,
                        tid,
                        tname
                    }
                })
            }else if(type == 'History'){
                this.SHOW_DIALOG({
                    current: 'HistoryVersion',
                    title: name,
                    dialogIco: ext,
                    dialogData: {
                        ext,
                        fileid,
                        groupid,
                        fname,
                        parentid
                    }
                })
            }else if(type == 'Download'){
                
                this.download({fileid,groupid,sid})
            }else if(type == 'Delete'){
                this.route == 'latest' ? 
                this.SHOW_DIALOG({
                    title: this.$t('Deleterecord'),
                    size: 'small',
                    current: 'deleteRecord',
                    dialogData:{
                        fileid,
                        groupid,
                        sid,
                        fname,
                        name
                    }
                }) : this.route == 'received' ? 
                this.SHOW_DIALOG({
                    current: 'deleteFiles',
                    smodule: 'received',
                    title: this.$t('deleteFile'),
                    dialogData: {
                        sid,
                        fname: name
                    }
                }) :
                this.SHOW_DIALOG({
                    current: 'deleteFiles',
                    smodule: 'index',
                    title: this.$t('deleteFile'),
                    dialogData: {
                        fileid,
                        fname,
                        groupid
                    }
                })
            }else if(type == 'Recover'){
                this.SHOW_DIALOG({
                    title: this.$t('Recovertitle',{type: ftype == 'folder' ? 'folder' : 'file'}),
                    confirmInfo: this.$t('Recoverinfo',{type: ftype == 'folder' ? 'folder' : 'file',name: fname}),
                    current: 'Confirm',
                    smodule: 'index',
                    action: 'recover',
                    dialogData: {
                        safe: true,
                        paload: fileid
                    }
                })
            }else if(type == 'Deletefoever'){
                this.SHOW_DIALOG({
                    title: this.$t('Deleteftitle',{type: ftype == 'folder' ? 'folder' : 'file'}),
                    confirmInfo: this.$t('Deletefinfo',{name: fname}),
                    current: 'Confirm',
                    smodule: 'index',
                    action: 'deleteP',
                    dialogData: {
                        paload: fileid
                    }
                })
            }else if(type == 'Stopshare'){
                 this.SHOW_DIALOG({
                    title: this.$t('Stopshare'),
                    confirmInfo: this.$t('Stoptip'),
                    current: 'Confirm',
                    smodule: 'index',
                    action: 'stopShare',
                    dialogData: {
                        fileid,
                        groupid,
                        share
                    }
                })
            }
            this.HIDE_CONTEXTMENU()
        }
    },
    mounted(){
        document.body.addEventListener('click',this.clickoutside)
    },
    computed:{
        ...mapState([
            'left',
            'top',
            'bottom',
            'right',
            'contextData',
            'contextMenuVisible',
            'route',
            'shareable'
        ]),
        ...mapState('index',[
            'trash'
        ]),
        ...mapState('team',[
            'currentTeam'
        ]),

        style(){
            let style = {}
            this.left ? style.left = `${this.left}px` : style.right = `${this.right}px`
            this.bottom ? style.bottom = `${this.bottom}px` : style.top = `${this.top}px`
            return style
        },
        isStared(){
            return this.contextData.stared === 1 ? 'unstar' : 'star'
        },
        menu(){
            let {ftype,sid,name,parentid,tid,fileid,groupid} = this.contextData
            let key = tid ? 'team' : this.$route.name == 'trashFolder' ? 'trashFolder' : this.trash ? 'trash' : 
            ftype === 'folder' && name.toLowerCase() == 'messenger' && parentid === 0 && this.route !== 'teams' ? 'messenger' :
            ftype === 'folder' ?
             'cloudFolder' : sid && this.route == 'starred' ? 'starShare' : this.$route.name == 'shared' ? 'sharedFile' : sid ? 'shareFile' : 'cloudFile'
            let menu = menus[key]
            if(window.cefQuery){
                menu = menu.filter(item => item.key != 'Download')
            }
            if (this.route == 'teams') {
                switch (this.currentTeam.member_role) {
                    case 'read_member':
                        menu = menu.filter(item => item.key == 'Star' || item.key == 'Download')
                        break;
                }
            }

            // 禁用分享
            !this.shareable ? menu = menu.filter(item => item.key != 'Share') : ''

            return menu
        }
    },
    beforeDestroy(){
        document.body.removeEventListener('click',this.clickoutside)
    }
}
</script>

<style>
.list-actions.contextMenu{
    top: unset;
    left: unset;
    right: unset;
    bottom: unset;
}
.contextMenu{
    z-index: 2;
    right: unset;
}
.action-danger{
    color: #e97663;
}
.contextMenu .list-action-item{
    /* padding-left: 36px; */
}
</style>


// WEBPACK FOOTER //
// src/components/ContextMenu.vue